"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var WebserviceRoute = {
  CLIENT_SIDE: 'wsvc',
  SERVER_SIDE: 'svc'
};
var _default = exports.default = WebserviceRoute;